import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../shared/constants';
import { CategoryMappingGridResultModel, CategoryMasterGridResultModel } from '../shared/models/category-data.model';
import { HeaderFilterData } from '../shared/models/product.model';
import { HeaderFilterOption, LoadOptions } from '../shared/models/shared.model';

@Injectable({
  providedIn: 'root'
})
export class CategoryDataService {
  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/categorydatamapping';

  constructor(private httpClient: HttpClient) { }

  public getCategoryMappingGrid(param: LoadOptions): Observable<CategoryMappingGridResultModel> {
	return this.httpClient
	.post<CategoryMappingGridResultModel>(
		this.url + `/getCategoryMappingGrid/`, param,
		{ headers: this.headers }
	);
  }

  public getCategoryMasterGrid(param: LoadOptions): Observable<CategoryMasterGridResultModel> {
	return this.httpClient
	.post<CategoryMasterGridResultModel>(
		this.url + `/getCategoryMasterGrid/`, param,
		{ headers: this.headers }
	);
  }

  public mappingAction(param): Observable<any> {
	return this.httpClient
		.post<any>(
			this.url + '/mappingAction', param,
			{ headers: this.headers }
		);
  }

  public getHeaderFiltersCategoryMapping(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
			.post<HeaderFilterData[]>(
				this.url + `/getHeaderFiltersCategoryMapping`, param,
				{ headers: this.headers }
			);
  }

  public getHeaderFiltersCategoryMaster(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
		return this.httpClient
			.post<HeaderFilterData[]>(
				this.url + `/getHeaderFiltersCategoryMaster`, param,
				{ headers: this.headers }
			);
  }
}
